import { atom, useAtom, useSetAtom } from 'jotai';

export type DisableFlowModalContext = {
  isOpened: boolean;
  flowId: string;
};
export const disableFlowModalAtom = atom<DisableFlowModalContext | null>();

export const useDisableFlowModalContext = () => {
  return useAtom(disableFlowModalAtom);
};

export const useSetDisableFlowModalContext = () => {
  return useSetAtom(disableFlowModalAtom);
};
